import script from "./CardSelectionSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./CardSelectionSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./CardSelectionSkeleton.vue?vue&type=style&index=0&id=4dbe5256&lang=scss"

const __exports__ = script;

export default __exports__